/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavContent_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "AccountNavContent_user";
};
export type AccountNavContent_user$data = AccountNavContent_user;
export type AccountNavContent_user$key = {
    readonly " $data"?: AccountNavContent_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNavContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'b80dab78d9d5f6907cb74ba4d3bd5439';
export default node;
